import { InjectionToken } from '@angular/core';
import { AppConfig } from '@app/types/global.type';
import { environment } from '@env/environment';

export const config: AppConfig = {
  env: String(environment.ENV),
  sapphireApiUrl: String(environment.SAPPHIRE_API_URL),
  sapphireMgmtApiUrl: String(environment.SAPPHIRE_MGMT_API_URL),
  tenant: String(environment.TENANT),
  sapphire1WebUrl: String(environment.SAPPHIRE1_WEB_URL),
  uumLogoutUrl: String(environment.UUM_LOGOUT_URL),
};

export const configProvider = new InjectionToken<AppConfig>('app.config');
